
const topicManagement = () => import('./topicManagement');
const MusicClassify = () => import('./MusicClassify');



const articleInformationManagement = [


  {
    path: 'topicManagement',
    name: 'topicManagement',
    component: topicManagement,
    meta: {
      title: '音乐列表'
    }
  },
  {
    path: 'MusicClassify',
    name: 'MusicClassify',
    component: MusicClassify,
    meta: {
      title: '分类管理'
    }
  },

];
export default articleInformationManagement;